import React, { useEffect, useState } from "react";

const AppDataContext = React.createContext({
    update: (d) => { },
    replace: (d) => { },
    reset: () => { },
    isLoanTypeStepCompleted: false,
    setLoanType: (data) => { },
    getLoanType: () => { },
    isLoanRequirementsStepCompleted: false,
    setLoanRequirements: (data,dirtyForm) => { },    
    getLoanRequirements: () => { },
    isPersonalDetailsStepCompleted: false,
    setPersonalDetails: (data) => { },
    getPersonalDetails: () => { },
    isLivingSituationStepCompleted: false,
    setEmploymentDetails: (data) => { },
    getEmploymentDetails: () => { },
    setLivingSituation: (value, currentAddress, prevAddress) => { },
    getLivingSituation: () => { },
    setLoanMatchesData: (data) => { },
    setUiCacheKey: (value) => { },
    approvalId: "",
    setApprovalId: (val) => { },
    getRequestBody: (key) => { },

    //TODO: Can we remove this empty method?
    setLoanRequirementsAndPersonDetails: (loanRequirements, personDetails) => { },

    data: {},
});

export const AppDataContextProvider = (props) => {
    const key = "_retail_finance";
    const trackingId = window.AppData.trackingId;
    const storedData = JSON.parse(window.sessionStorage.getItem(key)) || {trackingId};
    const [data, setData] = useState(storedData.trackingId === trackingId ? storedData : {trackingId});

    const update = (d) => {
        const current = data || {};
        const uiCacheKey = (new Date()).toJSON();
        const newData = { uiCacheKey: uiCacheKey, ...current, ...d };
        setStateAndSessionData(newData);
    };

    const updateNoCacheRefresh=(d)=>{
        const current = data || {};        
        const newData = {...current, ...d };
        setStateAndSessionData(newData);
    }

    const setStateAndSessionData=(newData)=>{
        const current = data || {};
        setData(newData);
        window.sessionStorage.setItem(
            key,
            JSON.stringify({ ...current, ...newData })
        );
    }
    
    
    const reset = () => {
        setData({});
    };

    useEffect(() => {
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }, [data]);

    return (
        <AppDataContext.Provider
            value={{
                update: update,
                replace: setData,
                reset: reset,
                isLoanTypeStepCompleted: data.isLoanTypeStepCompleted,
                setLoanType: (value) =>
                    update({
                        isLoanTypeStepCompleted: true,
                        loanTypeData: value,
                    }),
                getLoanType: () => data.loanTypeData,
                isLoanRequirementsStepCompleted:
                    data.isLoanRequirementsStepCompleted,
                setLoanRequirements: (value, dirtyForm) => {
                        if(dirtyForm) {
                            update({
                                isLoanRequirementsStepCompleted: true,
                                loanRequirementsData: value,
                            })
                        }
                        else {
                            updateNoCacheRefresh({
                                isLoanRequirementsStepCompleted: true,
                                loanRequirementsData: value,
                            })
                        }                        
                    },                
                getLoanRequirements: () => data.loanRequirementsData,

                isPersonalDetailsStepCompleted:
                    data.isPersonalDetailsStepCompleted,
                setPersonalDetails: (value) =>
                    update({
                        isPersonalDetailsStepCompleted: true,
                        personalDetailsData: value,
                    }),
                getPersonalDetails: () => data.personalDetailsData,
                isLivingSituationStepCompleted:
                    data.isLivingSituationStepCompleted,
                setLivingSituation: (value, currentAddress, prevAddress) =>
                    update({
                        isLivingSituationStepCompleted: true,
                        livingSituationData: {
                            livingSituation: value,
                            currentAddress: currentAddress,
                            prevAddress: prevAddress,
                        },
                    }),
                getLivingSituation: () => data.livingSituationData,
                setLoanMatchesData: (value) => {
                    update(value)
                },
                approvalId: data.approvalId,
                setApprovalId: (val) => {
                    update({ approvalId: val })
                },

                getRequestBody: (key) => {
                    switch (key) {
                        case "living-situation":
                            return {
                                loanType: data.loanTypeData?.loanType,
                                personalDetails: data.personalDetailsData
                            };
                        case "loan-matches":
                            return {
                                personalDetails: data.personalDetailsData,
                                livingSituation: data.livingSituationData,
                                employmentDetails: data.employmentDetailsData,
                                loanDetails: data.loanRequirementsData,
                                loanTypeDetails: data.loanTypeData,
                                uiCacheKey: data.uiCacheKey
                            };
                        case "loan-requirements":
                            return {
                                loanAmount: data.loanRequirementsData?.loanAmount,
                                deposit: data.loanRequirementsData?.deposit,
                                vehiclePrice: data.loanRequirementsData?.vehiclePrice,
                                stockId: data.loanRequirementsData?.stockId,
                                assetCondition: data.loanRequirementsData?.assetCondition,
                                buildYear: data.loanRequirementsData?.buildYear
                            };
                        default:
                            return (null);
                    }
                },

                isEmploymentDetailsStepCompleted:
                    data.isEmploymentDetailsStepCompleted,
                setEmploymentDetails: (value) =>
                    update({
                        isEmploymentDetailsStepCompleted: true,
                        employmentDetailsData: value,
                    }),
                getEmploymentDetails: () => data.employmentDetailsData,

                setLoanRequirementsAndPersonDetails: (loanRequirements, personDetails) =>
                    update({
                        loanRequirementsData: loanRequirements,
                        personalDetailsData: personDetails
                    }),

                data: data,
            }}
        >
            {props.children}
        </AppDataContext.Provider>
    );
};

export default AppDataContext;
